import React, { createContext } from 'react';
import { getDeviceContext } from 'utils/deviceContext';
const deviceContext = getDeviceContext();
const DeviceContext = createContext(deviceContext);

export const withDeviceContext = (Component) => {
  const ComponentWithDeviceContext = (props) => (
    <DeviceContext.Consumer>
      {(_device) => <Component {...props} {...deviceContext} />}
    </DeviceContext.Consumer>
  );

  if (process.env.NODE_ENV === 'development') {
    ComponentWithDeviceContext.displayName = `withDeviceContext(${
      Component.displayName || Component.name || 'Component'
    })`;
  }

  return ComponentWithDeviceContext;
};

export default DeviceContext;
